module.exports = __webpack_public_path__ + "img/avatar.ceb95a33.jpg";